var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGardeningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2851 0.378352C53.1151 0.288352 51.9351 0.248352 50.7451 0.248352C23.1351 0.248352 0.745132 22.6384 0.745132 50.2484C0.745132 77.8584 23.1351 100.248 50.7451 100.248C72.3051 100.248 90.6751 86.5984 97.6951 67.4784C99.6651 62.1084 100.745 56.2984 100.745 50.2484C100.745 23.8284 80.2451 2.18835 54.2851 0.378352ZM6.74513 50.2484C6.74513 42.7784 8.61513 35.7484 11.9151 29.5784C17.1751 19.7384 26.0751 12.1384 36.7951 8.53835V47.4984L36.3751 47.0784C36.9651 35.0784 27.8251 27.5684 16.1251 28.9484C14.7451 40.6584 22.2551 49.7984 34.2551 49.1984L36.8051 51.7484V75.0883L36.3851 74.6684C36.9751 62.6684 27.8351 55.1584 16.1351 56.5384C14.7551 68.2484 22.2651 77.3884 34.2651 76.7884L36.8151 79.3383V91.9784C19.3751 86.1284 6.76513 69.6383 6.76513 50.2584L6.74513 50.2484ZM90.8151 68.4284C83.8751 83.6484 68.5251 94.2484 50.7451 94.2484C46.9651 94.2484 43.2951 93.7684 39.7951 92.8684V34.9684C39.9151 34.8984 40.0351 34.8384 40.1351 34.7384L42.7251 32.1484C54.7251 32.7384 62.2351 23.5984 60.8551 11.8984C49.1451 10.5184 40.0051 18.0284 40.6051 30.0284L39.7951 30.8384V7.65835C43.3051 6.75835 46.9651 6.24835 50.7451 6.24835C55.7951 6.24835 60.6451 7.11835 65.1651 8.68835V32.6584H72.1651V11.8384C85.6251 19.3684 94.7451 33.7684 94.7451 50.2484C94.7451 56.7284 93.3351 62.8884 90.8151 68.4284Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1451 36.3784H65.2451C65.2451 39.0884 63.0451 41.2884 60.3351 41.2884H53.7851C52.9551 41.2884 52.2851 41.9584 52.2851 42.7884V62.8884C52.2851 71.9484 59.6151 82.0884 68.6651 82.1184C68.6651 82.1184 68.6851 82.1184 68.6951 82.1184C68.7051 82.1184 68.7151 82.1184 68.7251 82.1184C77.7751 82.0784 85.1051 71.9384 85.1051 62.8784V42.7784C85.1051 41.9484 84.4351 41.2784 83.6051 41.2784H77.0551C74.3451 41.2784 72.1451 39.0784 72.1451 36.3684V36.3784ZM74.2551 48.1784L70.3351 62.8184C70.1351 63.5884 69.4551 64.0984 68.6651 64.0984C67.8751 64.0984 67.2051 63.5784 66.9951 62.8184L63.0751 48.1784C62.9451 47.6784 63.2351 47.1684 63.7351 47.0384C64.2351 46.9084 64.7451 47.1984 64.8751 47.6984L68.6651 61.8484L72.4551 47.6984C72.5851 47.1984 73.1051 46.9084 73.5951 47.0384C74.0951 47.1684 74.3851 47.6784 74.2551 48.1784Z",
    fill: "#00FFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1711",
    x: -0.00000339746,
    y: -0.0000265539,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1711",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1711"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1711",
    result: "effect3_innerShadow_4857_1711"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGardeningIcon);
export default __webpack_public_path__ + "static/media/GardeningIcon.33f3af2836cfa6176d44755d493d180c.svg";
export { ForwardRef as ReactComponent };